// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"38291b6d","637":"38291b6d"}[chunkId] + ".chunk.css";
};